import { useEffect, useState } from "react";
import { MondayApiQueryInstance } from "../../services/monday/monday-service-ts";
import logger from "../../lib/logger";

const BIG_ACCOUNT_STORAGE_KEY = "isBigAccount";
const BIG_ACCOUNT_THRESHOLD = 500;

const readCachedBigAccount = (): boolean | null => {
  const cached = localStorage.getItem(BIG_ACCOUNT_STORAGE_KEY);
  if (cached === null) return null;
  try {
    return JSON.parse(cached) as boolean;
  } catch {
    return null;
  }
};

const useBigAccount = (): boolean => {
  const [isBigAccount, setIsBigAccount] = useState<boolean>(true);

  useEffect(() => {
    const fetchAccountSize = async () => {
      const cached = readCachedBigAccount();
      if (cached !== null) {
        setIsBigAccount(cached);
        return;
      }

      try {
        const boardSize = await MondayApiQueryInstance.getAccountSize();
        const result = boardSize.length >= BIG_ACCOUNT_THRESHOLD;
        localStorage.setItem(BIG_ACCOUNT_STORAGE_KEY, JSON.stringify(result));
        setIsBigAccount(result);
      } catch (error: any) {
        logger.error("Error fetching account size", error.message);
      }
    };

    fetchAccountSize();
  }, []);

  return isBigAccount;
};

export default useBigAccount;
